//search
export const NOTIFICATION_SEARCH_START_LOADING = "NOTIFICATION_SEARCH_START_LOADING";
export const NOTIFICATION_SEARCH_END_LOADING = "NOTIFICATION_SEARCH_END_LOADING";
export const NOTIFICATION_SEARCH_LOADED = "NOTIFICATION_SEARCH_LOADED";
export const SET_NOTIFICATION_FILTER = "SET_NOTIFICATION_FILTER";

//View
export const NOTIFICATION_START_LOADING = "NOTIFICATION_START_LOADING";
export const NOTIFICATION_END_LOADING = "NOTIFICATION_END_LOADING";
export const NOTIFICATION_LOADED = "NOTIFICATION_LOADED";